<template>
  <div class="point-page" v-if="pageData.wells && pageData.wells.length > 0">
    <el-collapse accordion class="home-msg_collapse">
      <el-collapse-item>
        <template slot="title">
          <div class="spaceLeft home-msg_collapse_head">
            <div>
              <svg-icon icon-class="tn-down" class="icon-arrow" />
              <span>Measurement Point {{ pointIndex + 1 }}</span>
            </div>
          </div>
        </template>
        <div>
          <el-form
            class="page-form point-form"
            ref="pageForm"
            :model="pageData"
            label-position="left"
          >
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item
                  prop="location_id"
                  label="location_id of Measurement Point"
                >
                  {{ pageData.location_id }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  prop="location"
                  label="location of Measurement Point"
                >
                  {{ pageData.location }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <template v-for="(well, index) in pageData.wells">
            <el-collapse
              accordion
              class="sub-collapse"
              :key="index"
            >
              <el-collapse-item>
                <template slot="title">
                  <div class="spaceLeft sub-collapse_head">
                    <div>
                      <svg-icon icon-class="tn-down" class="icon-arrow" />
                      <span>well {{ pointIndex + 1 + "-" + (index + 1) }}</span>
                    </div>
                  </div>
                </template>
                <el-form
                  class="page-form point-form"
                  ref="pageWellForm"
                  :rules="annualReview ? pageWellRules : {}"
                  :model="well"
                  label-position="left"
                >
                  <el-row :gutter="40">
                    <el-col :span="12">
                      <el-form-item prop="location_id" label="location_id:">
                        {{ well.location_id }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        prop="location"
                        label="location of Measurement Point"
                      >
                        {{ well.location }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="aerLicensee" label="AER Licensee:">
                        {{ well.aerLicensee }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="aerLicenseNo" label="AER License No:">
                        {{ well.aerLicenseNo }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        prop="aerSurfaceLocation"
                        label="AER surface location"
                      >
                        {{ well.aerSurfaceLocation }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="UWI" label="AER UWI:">
                        {{ well.UWI }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item
                        prop="fromToIDIdentifier"
                        label="FromToIDIdentifier:"
                      >
                        {{ well.fromToIDIdentifier }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="sulphur" label="Sulphur Content:">
                        <span v-if="!annualReview">{{ well.sulphur }} %</span>
                        <el-input
                          style="width:2rem"
                          v-else
                          v-model="well.sulphur"
                          type="text"
                          auto-complete="off"
                          placeholder="Please fill in"
                        >
                        <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="APIGravity" label="API Gravity:">
                        <span v-if="!annualReview">
                          {{ well.APIGravity }}
                        </span>
                        <el-input
                          style="width:2rem"
                          v-else
                          v-model="well.APIGravity"
                          type="text"
                          auto-complete="off"
                          placeholder="Please fill in"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12">
                      <el-form-item prop="oilAnalysis" label="OIL ANALYSIS:">
                        <el-button type="text" v-if="!annualReview" @click="openPdfView(well.oilAnalysis)">
                          {{ well.oilAnalysis }}
                        </el-button>
                        <file-upload
                          v-else
                          ref="oilAnalysis"
                          @onSuccess="handleFileSuccess($event, well)"
                          @onRemove="handleFileRemove($event, well)"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <pdfView ref="pdfView" />
  </div>
</template>

<script>
import { updateWellParams } from "@/api/producer.js";
import pdfView from "@/components/PdfView/index.vue";
export default {
  props: {
    pointIndex: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    pageData: {
      type: Object,
      default: () => {
        return {
          location: undefined,
          location_id: undefined,
          wells: []
        };
      }
    },
    annualReview: {
      type: Boolean
    }
  },
  components: { pdfView },
  data() {
    return {
      pageWellRules: {
        sulphur: [
          {
            required: true,
            trigger: "blur",
            message: "Sulphur Content cannot be empty"
          }
        ],
        APIGravity: [
          {
            required: true,
            trigger: "blur",
            message: "APIGravity cannot be empty"
          }
        ],
        oilAnalysis: [
          {
            required: true,
            trigger: "blur",
            message: "OIL ANALYSIS Content cannot be empty"
          }
        ]
      }
    };
  },
  computed: {},
  methods: {
    handleFileSuccess({ response, file, fileList }, item) {
      item.oilAnalysis = response.result.fileName;
    },
    handleFileRemove(fileList, item) {
      item.oilAnalysis = undefined;
    },
    initFile() {
      if (this.$refs.oilAnalysis) {
        this.$refs.oilAnalysis.forEach((i, index) => {
          this.$refs.oilAnalysis[index].setFile(
            this.pageData.wells[index].oilAnalysis
          );
        });
      }
    },
    // showWell(well) {
    //   if (this.annualReview) {
    //     return well.isAnnual;
    //   } else {
    //     return true;
    //   }
    // },
    check() {
      const wellFormList = this.$refs.pageWellForm;
      if (this.pageData.wells.length > 0) {
        for (let i = 0; i < wellFormList.length; i++) {
          let wellFlag = false;
          wellFormList[i].validate(valid => {
            wellFlag = valid;
          });
          if (!wellFlag) {
            this.$message.error(
              "Well " +
                (this.pointIndex + 1) +
                "-" +
                (i + 1) +
                ": Please complete the required items"
            );
            return;
          }
        }
      }
      return true;
    },
    updateWellParams(well){
      const self = this;
      return new Promise((resolve, reject) => {
        let param = {
          wellID: well.wellID,
          sulphur: well.sulphur,
          APIGravity: well.APIGravity,
          oilAnalysis: well.oilAnalysis,
        }
        updateWellParams(param)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            self.loading = false;
            reject(error);
          });
      });
    },
    updateWell() {
      let resList = [];
      this.loading = true;
      this.pageData.wells.forEach(i => {
        resList.push(this.updateWellParams(i));
        this.loading = false;
      })
      return resList;
    },
    openPdfView(name) {
      this.$refs.pdfView.open({
        name: name
      });
    }
  },
  mounted() {
    this.initFile();
  }
};
</script>
<style scoped lang="scss">
.point-page {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: none;
  .home-msg_collapse {
    border: none;
    ::v-deep .el-collapse-item__header {
      border-color: rgba(0, 0, 0, 0.1);
      color: #000;
      font-weight: bold;
      font-size: 0.18rem;
      padding: 0.24rem 0.32rem;

      .icon-arrow {
        transform: rotate(-90deg);
      }
      &.is-active {
        .icon-arrow {
          color: #666;
          transform: rotate(0deg);
          display: inline-block;
        }
      }
    }
    ::v-deep .el-collapse-item__content {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 0.18rem;
      color: #575757;
      padding: 0;
    }
    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
    .home-msg_collapse_head {
      width: 100%;
      .time-text {
        color: #a3a3a3;
        font-weight: normal;
      }
    }

    .point-form {
      padding: 0 0.52rem;
      .el-form-item {
        margin: 0.16rem 0 0.22rem 0;
      }
    }
  }

  .sub-collapse {
    border: none;
    background: #fafafa;
    ::v-deep .el-collapse-item__header {
      border-bottom: none;
      color: #000;
      font-weight: bold;
      font-size: 0.18rem;
      padding: 0.24rem 0.24rem;
      background: #fafafa;
      .icon-arrow {
        transform: rotate(-90deg);
      }
      &.is-active {
        .icon-arrow {
          color: #666;
          transform: rotate(0deg);
          display: inline-block;
        }
      }
    }
    ::v-deep .el-collapse-item__content {
      border-bottom: none;
      font-size: 0.18rem;
      color: #575757;
      padding: 0;
    }
    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
      background: #fafafa;
    }
    ::v-deep .el-collapse-item__arrow {
      display: none;
    }
    .sub-collapse_head {
      width: 100%;
      .time-text {
        color: #a3a3a3;
        font-weight: normal;
      }
    }
    .el-collapse-item:last-child {
      margin-bottom: 0;
      border-bottom: 1px solid #e6ebf5;
      margin: 0 0.24rem;
    }
    .point-form {
      padding: 0 0.5rem;
      .el-form-item {
        margin: 0 0 0.2rem 0;
      }
    }
  }
}
</style>
